import { useState, useEffect, useCallback, useContext } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Context } from '../../index';
import DonateBonuses from '../Modules/DepositBonus/DonateBonuses'
import './modal.css'
import SpinnerLoader from '../Loaders/SpinnerLoader';

let minAmount = 100;
let isInputEnabled = true;

function DonateMethod({img, label, enabled, invisible, isActive, method}:any) {
    const enabledActiveBtn = enabled & isActive ? ' refill-window__payment-btn active':'';
    return(
        <div className={enabled ? `refill-window__payment` : `refill-window__payment disabled`} hidden={invisible ? true:false}>
            <button className={`refill-window__payment-btn ${enabledActiveBtn}`} onClick={method} tabIndex={!enabled ? -1: undefined } disabled={enabled ? false:true}>
                <img className='refill-window__payment-icon' src={img}></img>
                {label && <div className="refill-window__payment-label">{label}</div>}
            </button>
        </div>
    )
}

const DonateButton = ({store, buttonText, placeholderText, enabled, inputEnabled, isActive, inputValue, lang, bonusClick, amountCategory}:any) => {
    const { depositBonuses } = store
    const [isActionLoaded, setActionLoaded] = useState(true);
    
    async function redirectMethod() {
        setActionLoaded(false);
        const autoClose = setTimeout(() => {
            setActionLoaded(true);
            return () => clearTimeout(autoClose)
        }, 10 * 1000);
        
        await store.donate({inputValue, isActive, lang});
        setActionLoaded(true);
    }

    return(
        <div className="refill-window__content__pay">		
            {   inputEnabled &&
                <div className="left">	
                    <div className={'refill-window__amount-wrapper'} id="amount-wrapper">						
                        <div className="refill-window__pre-input">₽</div>									
                        <input className="refill-window__amount-input" autoComplete='off' placeholder={placeholderText} id="refill-window__amount-input" type="text" pattern="[0-9]*" maxLength={7} value={inputValue!=0 ? new Intl.NumberFormat('ru-RU').format(inputValue): ''} onChange={e => store.setDonateAmount(e.target.value.replace(/[^0-9]/g,''))} />								
                    </div>
                    {   depositBonuses.length > 0 &&
                        <div className="pay_bonuses">
                            {   depositBonuses.map((el:any) => (
                                <button className={`pay_bonus ${el.amount >= amountCategory ? 'opacity-100':''} ${el.amount >= amountCategory && inputValue >= el.amount ? 'active':''}`} key={el.id} 
                                        onClick={e => bonusClick(el.amount)}>
                                    <div className="pay_bonus_wrap">+{el.bonus}%</div>
                                </button>					
                            ))}
                        </div>
                    }
                </div>
            }
            <div className="right">
                <button className={enabled ? 'refill-window__button': 'refill-window__button disabled'} disabled={!enabled || !isActionLoaded} onClick={() => redirectMethod()}>
                    {isActionLoaded ? buttonText : <SpinnerLoader className='spinner_in_button' />}
                </button>
            </div>
        </div>
    )
}

function DonateModal() {
    const {store} = useContext(Context);
    const {depositBonuses} = store
    const open = store.donateModalOpen;
    const { t, i18n } = useTranslation()
    const lang = i18n.language
    const [isActive, setActive] = useState('cent')
    const [openInfo, setOpenInfo] = useState(false)
    const inputValue = store.donateAmount

    const amountCategory = depositBonuses.slice().sort((a, b) => b.amount - a.amount).find(v => inputValue >= v.amount) || {amount: 0, bonus: 0}
    const minBonusAmount = Math.min(...depositBonuses.map(({amount}) => amount))
    const finalAmount = amountCategory?.bonus ? inputValue*(1 + amountCategory.bonus / 100): inputValue
    
    function handleClick(min:any, method:any) {
        setActive(method);
        minAmount = min;
        if (method==='skinify' || method==='telegram') {
            isInputEnabled = false;
        }
        else {
            isInputEnabled = true;
        }
    }
    
    function closeModal() {
        if (openInfo) setOpenInfo(false)
        else store.setDonateModalOpen(false)
    }

    function bonusClick(amount:number) {
        store.setDonateAmount(amount)
        if (isActive==='skinify' || isActive==='telegram') handleClick(100,'cent')
        setOpenInfo(false)
    }

    const escFunction = useCallback((e:any) => {
        if (e.key === "Escape") closeModal()
    }, [openInfo, open])

    useEffect(() => {
        if (open) {
            document.addEventListener("keydown", escFunction, false);
            return () => document.removeEventListener("keydown", escFunction, false)
        }
      }, [escFunction])

    useEffect(() => {
        if (open) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [open])
    return createPortal(
        <div className={open ? 'modal modal__donate active':'modal modal__donate'}>
            <div className="modal_close" onClick={e => closeModal()}></div>
            <div className={open ? 'modal__content-1 active':'modal__content-1'}>
                {   depositBonuses.length > 0 &&
                    <div className={openInfo ? "modalDonate__info active":"modalDonate__info"}>
                        <div className="modalDonate__info_wrapper">
                            <div className="refill-window_topRight">
                                <button className="refill-window__close" onClick={e => setOpenInfo(false)}>
                                    <svg viewBox="0 0 24 24" className="refill-window__close_svg" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_iconCarrier"> <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM13.92 16.13H9C8.59 16.13 8.25 15.79 8.25 15.38C8.25 14.97 8.59 14.63 9 14.63H13.92C15.2 14.63 16.25 13.59 16.25 12.3C16.25 11.01 15.21 9.97 13.92 9.97H8.85L9.11 10.23C9.4 10.53 9.4 11 9.1 11.3C8.95 11.45 8.76 11.52 8.57 11.52C8.38 11.52 8.19 11.45 8.04 11.3L6.47 9.72C6.18 9.43 6.18 8.95 6.47 8.66L8.04 7.09C8.33 6.8 8.81 6.8 9.1 7.09C9.39 7.38 9.39 7.86 9.1 8.15L8.77 8.48H13.92C16.03 8.48 17.75 10.2 17.75 12.31C17.75 14.42 16.03 16.13 13.92 16.13Z"></path> </g></svg>
                                </button>
                            </div>
                            <div className="modalDonate__info_wrapper-title">{t('main.header.bonusTitle')}</div>
                            <DonateBonuses additionalClass='donate' bonusClick={bonusClick} />
                            <div className="modalDonate__info_wrapper-footer">
                                {t('modal.donate.bonus_description')}
                            </div>
                        </div>
                    </div>
                }
                <div className="refill-window__header">
                    <div className="refill-window__title">
                        <div className="svgrep">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27"><g fill="#fff"><path d="M3.138 24h19.724C24.61 24 26 22.647 26 20.945V6.11c0-1.702-1.39-3.054-3.138-3.054h-2.241v2.618h2.241c.269 0 .448.174.448.436v9.164H2.69V6.109c0-.262.179-.436.448-.436h2.241V3.055H3.138C1.39 3.055 0 4.407 0 6.109v14.836C0 22.648 1.39 24 3.138 24zm20.172-6.11v3.055c0 .262-.179.437-.448.437H3.138c-.269 0-.448-.175-.448-.437v-3.054h20.62z"></path><path d="M11.655 0v8.204l-2.69-2.619-1.882 1.833 4.976 4.844c.538.523 1.39.523 1.882 0l4.976-4.844-1.883-1.833-2.69 2.619V0h-2.689z"></path></g></svg>
                        </div>
                        <div className="refill-window__titleText">{t('modal.donate.title')}</div>
                    </div>
                    <div className="refill-window_topRight">
                        {   depositBonuses.length > 0 &&
                            <button className="refill-window__help" onClick={() => setOpenInfo(true)}>
                                {t('modal.donate.bonuses')}
                            </button>
                        }
                        <button className="refill-window__close" onClick={() => closeModal()}>
                            <svg className="refill-window__close_svg" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_iconCarrier"><path d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"></path></g></svg>
                        </button>
                    </div>
                </div>
                <div className="refill-window__payments">
                    {/* <DonateMethod 
                        img='/img/donate/VisaMirSBP.svg'
                        label='Tome'
                        enabled={true}
                        method={() => handleClick(100,'tome')}
                        isActive={isActive === 'tome'}
                    /> */}
                    <DonateMethod 
                        img='/img/donate/VisaMirSBPUSDT.svg'
                        label='Cent App'
                        enabled={true}
                        method={() => handleClick(100,'cent')}
                        isActive={isActive === 'cent'}
                    />
                    <DonateMethod 
                        img='/img/donate/VisaMir.svg'
                        label='Enot'
                        enabled={false}
                        invisible={true}
                        method={() => handleClick(100,'enot')}
                        isActive={isActive === 'enot'}
                    />
                    <DonateMethod 
                        img='/img/donate/VisaMir.svg'
                        label='FreeKassa'
                        enabled={true}
                        method={() => handleClick(1000,'freekassa')}
                        isActive={isActive === 'freekassa'}
                    />
                    <DonateMethod 
                        img='/img/donate/Paypal.svg'
                        label='Tebex'
                        enabled={true}
                        method={() => handleClick(500,'tebex')}
                        isActive={isActive === 'tebex'}
                    />
                    <DonateMethod 
                        img='/img/donate/Cryptos.svg'
                        label='Crypto'
                        enabled={true}
                        method={() => handleClick(500,'heleket')}
                        isActive={isActive === 'heleket'}
                    />
                    <DonateMethod 
                        img='/img/donate/Skins.svg'
                        label=''
                        enabled={true}
                        method={() => handleClick(0,'skinify')}
                        isActive={isActive === 'skinify'}
                    />
                    <DonateMethod 
                        img='/img/donate/Telegram.svg'
                        label=''
                        enabled={true}
                        method={() => handleClick(0,'telegram')}
                        isActive={isActive === 'telegram'}
                    />
                    <DonateMethod
                        label=''
                        enabled={false}
                    />
                    <DonateMethod
                        label=''
                        enabled={false}
                    />
                </div>
                <div className="refill-window__bonus">
                    <span className={"refill-window__bonus-text active"}>
                        {
                            !['skinify','telegram'].includes(isActive) ? t('modal.donate.bonus'): 
                            isActive=='skinify'? t('modal.donate.skins'): t('modal.donate.telegram')
                        } 
                        <strong className={`refill-window__bonus-amount ${!['skinify','telegram'].includes(isActive) ? 'hoverable':''}`} onClick={() => store.setDonateAmount(minAmount)}>
                            {
                                !['skinify','telegram'].includes(isActive) ? new Intl.NumberFormat('ru-RU').format(Math.floor(minAmount))+' ₽': 
                                isActive=='skinify'? t('modal.donate.skin'): 'Telegram'
                            }
                        </strong>
                    </span>
                </div>
                <DonateButton 
                    buttonText={isActive!=='telegram' ? t('modal.donate.button'):t('modal.donate.contact')}
                    placeholderText={t('modal.donate.placeholder')}
                    enabled={!(inputValue < minAmount && (isActive!=='telegram' && isActive!=='skinify'))}
                    inputEnabled={isInputEnabled}
                    inputValue={inputValue}
                    isActive={isActive}
                    lang={lang}
                    store={store}
                    bonusClick={bonusClick}
                    amountCategory={amountCategory.amount}
                />
                {   depositBonuses.length > 0 &&
                    <span className={(inputValue>=minBonusAmount && inputValue>=minAmount && isActive!=='skinify' && isActive!=='telegram') ? "refill-footer__bonus active":"refill-footer__bonus"}>
                        {t('modal.donate.footer')} <strong className='refill-window__bonus_footer-amount'>{new Intl.NumberFormat('ru-RU').format(Math.floor(finalAmount))} ₽</strong>
                    </span>
                }
            </div>
        </div>,
        (document.getElementById('modal')!)
    )
}

export default observer(DonateModal);